import { call, put, select, spawn } from 'typed-redux-saga';

import { isMessengerIntegration, selectIsTeleMessenger } from '../../../../shared/features/config/selectors';
import { feedbackSaga } from '../../../../shared/features/feedback/sagas/feedbackSaga';
import { NOTIFICATIONS_MAP, notify } from '../../../../shared/features/notifications/ps-notifications';
import { selectIsUserB2BDomainMismatch } from '../../../../shared/features/user/selectors';
import { replace, SCREENS } from '../../../../shared/helpers/navigation';
import { disconnectConferenceAction } from '../../features/conference/slice';
import { DisconnectReason, NotificationId } from '../../types';
import { handleDisconnect } from './handle-disconnect';

export function* handleKick() {
    const isUserDomainMismatch = yield* select(selectIsUserB2BDomainMismatch);
    const isMessenger = yield* select(isMessengerIntegration);
    const isTeleMessenger = yield* select(selectIsTeleMessenger);

    if (!isUserDomainMismatch && !isMessenger && !isTeleMessenger) {
        yield* spawn(feedbackSaga);
    }

    yield put(
        disconnectConferenceAction({
            source: DisconnectReason.KICK,
        })
    );

    yield call(replace, SCREENS.CREATE_CALL, {});
    yield call(handleDisconnect);

    yield put(notify(NOTIFICATIONS_MAP[NotificationId.MODERATION_KICK]()));
}
